<div class="form-translations-modal">
  <div class="common__modal-header-block">
    <i class="lf-icon-translate common__icon-header">
    </i>
    <span
      class="common__text-header"
      [afTranslate]="'form-translations-modal.title'">
      _Traducciones del formulario
    </span>
    <i
      (click)="handleDismiss()"
      class="lf-icon-close common__icon-close-modal">
    </i>
  </div>
  <div class="form-translations-modal__body">
    <div class="form-translations-modal__translations-header">
      <advice-message
        class="form-configuration-modal__container-advice"
        [ngShow]="formTranslations.conceptInfo.hasInstances && formTranslations.showWarning"
        [icon]="'warning'"
        [type]="'warning'"
        [typeClass]="'no-margin'"
        [text]="'form-translations-modal.evaluated-concept' | afTranslate"
        (closeAdvice)="formTranslations.showWarning = false">
      </advice-message>
      <div
        class="form-translations-modal__translations-header--inner"
        [ngClass]="{
          'protection-data-modal__block-translations--error': !formTranslations.translationsValid
        }">
        <button
          *ngFor="let languageSelected of formTranslations.formTranslationsLanguagesSelected"
          class="protection-data-modal__block-translation-option"
          [ngClass]="{
            'protection-data-modal__block-translation-option--selected': languageSelected.active && !languageSelected.error,
            'protection-data-modal__block-translation-option--selected-error': languageSelected.active && languageSelected.error,
            'protection-data-modal__block-translation-option--error': !languageSelected.active && languageSelected.error
          }"
          (click)="changeActiveLanguagesSelected(languageSelected)">
          <span [ngShow]="formTranslations.formTranslationsLanguagesSelected.length < 6">
            {{languageSelected.text}}
          </span>
          <span [ngShow]="formTranslations.formTranslationsLanguagesSelected.length >= 6">
            {{languageSelected.appLanguage}}
          </span>
          <i
            class="lf-icon-close protection-data-modal__icon-close-language"
            [ngHide]="languageSelected.defaultOption"
            (click)="removeActiveLanguage(languageSelected)">
          </i>
          <svg
            class="protection-data-modal__triangle-block"
            [ngClass]="{
              'protection-data-modal__triangle-block--selected': languageSelected.active,
              'protection-data-modal__triangle-block--selected-error': languageSelected.active && languageSelected.error,
              'protection-data-modal__triangle-block--error': !languageSelected.active && languageSelected.error
            }">
            <polygon points="0,0 21,30 0,30" />
          </svg>
        </button>
        <div
          ngbDropdown
          [ngHide]="formTranslations.formTranslationsLanguagesSelected.length === formTranslations.formTranslationsLanguagesApp.length">
          <button
            ngbDropdownToggle
            class="protection-data-modal__select-language-button" >
            <span [afTranslate]="'protection-data-modal.add-translation'">
            </span>
            <i class="lf-icon-translate protection-data-modal__icon-translate">
            </i>
          </button>
          <div
            ngbDropdownMenu
            class="protection-data-modal__menu-select-languages dropdown-menu" >
            <div class="common__block-option-list header-nav__block-option-list">
              <div
                *ngFor="let language of formTranslations.formTranslationsLanguagesApp"
                (click)="selectLanguage(language)"
                [ngShow]="notSelectLanguage(language)"
                class="common__language-item">
                <span>
                  {{language.text}}
                </span>
                <span>
                  ({{language.specific}})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-translations-modal__translations-container">
      <div class="form-configuration-modal__container-group-inner">
        <div class="form-translations-modal__group-header">
          <input
            *ngIf="formTranslations.typeView === 'translationsViewEditable'"
            type="text"
            class="form-configuration-modal__input-group-name"
            [(ngModel)]="formTranslations.fieldContainer.name"
            maxlength="300"
          />
          <span
            *ngIf="formTranslations.typeView === 'translationsViewNoEditable'"
            class="form-translations-modal__group-name">
            {{formTranslations.fieldContainer.name}}
          </span>
        </div>
        <div class="form-configuration-modal__group-container">
          <div
            *ngFor="let containerField of formTranslations.fieldContainer.fields"
            class="customize-concept__field-item">
            <customize-fields
              [field]="containerField"
              [typeField]="'fieldContainer'"
              [typeView]="formTranslations.typeView"
              [contentTypeList]="formTranslations.contentTypeList"
              [disabled]="formTranslations.disabledGroup"
              [reportList]="formTranslations.reportList"
              [concept]="formTranslations.conceptInfo"
              [disabledFormTranslations]="containerField.disabledTranslations"
              (openField)="showField($event, formTranslations.fieldContainer)">
            </customize-fields>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="common__buttons-block common__buttons-block--modal">
    <button
      class="common__button common__button--clean"
      (click)="handleDismiss()"
      [afTranslate]="'common.cancel'">
      _Cancelar
    </button>
    <button
      type="submit"
      [disabled]="!formTranslations.hasChange"
      class="common__button common__button--active"
      (click)="handleAccept()"
      [afTranslate]="'common.save'">
      _Guardar
    </button>
  </div>
</div>
